
import { showVuePopup } from '../../utils/showVuePopup';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import WalletWithdraw from '../../popup/WalletWithdraw.vue';
import WalletTransaction from '../../popup/WalletTransaction.vue';
import WalletUpdate from '../../popup/WalletUpdate.vue';
import { useSession } from '../../stores/session';

export default {
	name: 'PopupWalletNavbar',
	setup() {

		const session = useSession();

		const btnClickWalletWithdraw = async () =>  {
			session.set('navbar_sub', 'wallet:withdraw');
			await showVuePopup(WalletWithdraw);
		}

		const btnClickWalletDepositAuto = async () => {
			session.set('navbar_sub', 'wallet:deposit');
			await showVuePopup(WalletDeposit);
		}

		const btnClickTransactionDeposit = async () => {
			session.set('navbar_sub', 'wallet:transaction');
			await showVuePopup(WalletTransaction);
		}

		const btnClickUpdateBank = async () => {
			session.set('navbar_sub', 'wallet:update');
			await showVuePopup(WalletUpdate);
		}

		return {
			session,
			btnClickWalletWithdraw,
			btnClickWalletDepositAuto,
			btnClickTransactionDeposit,
			btnClickUpdateBank,
		}
	}
}
